export default __webpack_public_path__ + "static/media/arrow-right-white.e17fa5f9.svg";